module.exports = __webpack_public_path__ + "img/LUB00414.bc35dcec.svg";